module.exports = __webpack_public_path__ + "856b9c367302a9281aec11a239641bb3.svg";